import { render, staticRenderFns } from "./PoolsCard.vue?vue&type=template&id=53f43182&scoped=true"
import script from "./PoolsCard.vue?vue&type=script&lang=js"
export * from "./PoolsCard.vue?vue&type=script&lang=js"
import style0 from "./PoolsCard.vue?vue&type=style&index=0&id=53f43182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f43182",
  null
  
)

export default component.exports